import React from 'react';

const About = () => {
  return <section className='section bg-yellow-200'>About</section>;
};

export default About;
